// Footer.jsx
import React from 'react';
import { Flame, Phone, Mail, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();
  const phoneNumber = '573184476101';
  const email = 'acsegcontraincendios@gmail.com';
  const address = 'Vía al Caimo Bambazu Casa 16';

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-gradient-to-br from-orange-500 to-orange-600 p-2 rounded-lg">
                <Flame className="text-white" size={24} />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg">Adriana Calero</h3>
                <p className="text-orange-500 text-sm">Seguridad Contra Incendios</p>
              </div>
            </div>

            <p className="text-gray-400 leading-relaxed mb-4">
              Protegiendo vidas y patrimonio con soluciones integrales de seguridad contra incendios.
            </p>

            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/share/14H6Gj7qXwe/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 hover:bg-orange-600 p-2 rounded-lg transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>

              <a
                href="https://www.instagram.com/acsegcontraincendios?igsh=MWk3dGFyZm12MHd3ag=="
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 hover:bg-orange-600 p-2 rounded-lg transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>

              <a
                href="https://youtube.com/@acsegcontraincendios?si=BT9yI_0at-Y-e1ae"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 hover:bg-orange-600 p-2 rounded-lg transition-colors"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="hover:text-orange-500 transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('nosotros')}
                  className="hover:text-orange-500 transition-colors"
                >
                  Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="hover:text-orange-500 transition-colors"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('productos')}
                  className="hover:text-orange-500 transition-colors"
                >
                  Productos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('galeria')}
                  className="hover:text-orange-500 transition-colors"
                >
                  Galería
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="hover:text-orange-500 transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Servicios</h4>
            <ul className="space-y-3">
              <li><a href="#" className="hover:text-orange-500 transition-colors">Venta de Extintores</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Mantenimiento</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Inspecciones</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Capacitaciones</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Instalación de Sistemas</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Asesoría en Seguridad</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="text-orange-500 flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-sm text-gray-400 mb-1">Teléfono</p>
                  <a
                    href={`tel:+${phoneNumber}`}
                    className="hover:text-orange-500 transition-colors"
                  >
                    318 447 6101
                  </a>
                </div>
              </li>

              <li className="flex items-start gap-3">
                <Mail className="text-orange-500 flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-sm text-gray-400 mb-1">Email</p>
                  <a
                    href={`mailto:${email}`}
                    className="hover:text-orange-500 transition-colors break-all"
                  >
                    {email}
                  </a>
                </div>
              </li>

              <li className="flex items-start gap-3">
                <MapPin className="text-orange-500 flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-sm text-gray-400 mb-1">Dirección</p>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=V%C3%ADa+al+Caimo+Bambazu+Casa+16"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-orange-500 transition-colors"
                  >
                    {address}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Adriana Calero Seguridad Contra Incendios. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                Términos y Condiciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;